import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { push } from 'redux-first-history';

import ContentColumn from '@starbucks-web/pattern-library/lib/components/content-column';
import FormContainer from '@starbucks-web/pattern-library/lib/components/form-container';

import FormWithMessaging from 'shared/app/components/form-with-messaging';
import ExternalLink from 'shared/app/components/external-link';
import H1 from 'shared/app/components/h1';
import { validateEmail } from 'shared/app/utils/validators';
import { queryParamsSelector } from 'shared/app/state/selectors/routes';
import { showUnexpectedErrorNotification } from 'shared/app/shell';
import { privacyStatementUrlSelector } from 'shared/app/state/selectors/privacy-and-terms.js';
import { signedInSelector } from 'shared/app/bundles/user';
import { commonMessages } from 'shared/app/messages';

import { setPrivacyPermissions } from 'shared/app/state/action-creators/privacy-permissions';
import PersonalInformationForm from './form';
import messages from './messages';

export const PersonalInformation = () => {
  const [loading, setLoading] = useState(false);
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const queryParams = useSelector(queryParamsSelector);
  const privacyStatementUrl = useSelector(privacyStatementUrlSelector);
  const signedIn = useSelector(signedInSelector);

  const isNativeView = Boolean(queryParams?.platform);
  if (signedIn && !isNativeView) {
    window.location = `/account/settings/privacy`;
  }

  const getFormfields = () => {
    return {
      emailAddress: {
        validator: validateEmail,
        required: true,
      },
    };
  };

  const handleSubmit = (fields) => {
    setLoading(true);
    dispatch(
      setPrivacyPermissions({
        optIn: false,
        email: fields.emailAddress,
      })
    )
      .then(() => {
        setLoading(false);
        dispatch(push('/personal-information/confirmation'));
      })
      .catch(() => {
        setLoading(false);
        dispatch(showUnexpectedErrorNotification());
      });
  };

  return (
    <React.Fragment>
      <Helmet title={formatMessage(messages.header)} />
      <ContentColumn className="py6 lg-py8" size="md">
        <div className="text-center">
          <H1 className="text-bold pb2" size="lg">
            {formatMessage(messages.header)}
          </H1>
        </div>
        <div className="py2">
          {formatMessage(messages.content, {
            privacyNotice: (
              <ExternalLink href={privacyStatementUrl}>
                {formatMessage(commonMessages.privacyNotice)}
              </ExternalLink>
            ),
          })}
        </div>
        <div className="py2">
          <FormContainer
            fields={getFormfields()}
            focusOnSubmitError
            onSubmit={handleSubmit}
          >
            <FormWithMessaging>
              <PersonalInformationForm loading={loading} />
            </FormWithMessaging>
          </FormContainer>
        </div>
      </ContentColumn>
    </React.Fragment>
  );
};

export default PersonalInformation;
